module.exports = __webpack_public_path__ + "img/wx_public.936f40a7.jpg";